import React from "react";
import { Button, SearchBar, Typography } from "@kitbird/core";
import styled from "styled-components";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import {
  CardContent, PageCard, PageWrapper, TitleContent,
} from "../../../components/Content/Content.style";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import BluebirdLogo from "../../../assets/icons/logogram_bb.png";
import { ActionSection } from "../../../components/Filter/Filter.style";
import { StickyTable } from "../../../components/Table/Table.style";
import VendorTable from "./components/VendorTable";
import ModalVendorForm from "./components/VendorFormModal";
import FilterDropdown from "../../../components/FilterDropdown";
import useVendor from "./useVendor";
import useAuth from "../../../components/Authentication/useAuth";
import ModalViewFile from "./components/ModalViewFile";
import PageLoading from "../../../components/Loading/PageLoading";

const vendorStatusOpts = [
  { label: "Lihat semua", value: "" },
  { label: "Aktif", value: "Y" },
  { label: "Non-aktif", value: "N" },
  { label: "Blacklist", value: "BL" },
];

const approvalStatusOpts = [
  { label: "Lihat semua", value: "" },
  { label: "Diproses", value: "OPEN" },
  { label: "Disetujui", value: "CLOSE" },
  { label: "Ditolak", value: "CANCEL" },
];

const Flex = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

const Vendor = () => {
  const { userAccount: { userPools = [] } } = useAuth();
  const useCustomHook = useVendor();
  const {
    params,
    setParams,
    isLoading,
    modalFormVendor,
    setModalFormVendor,
    setEditValues,
    setFiles,
    allDepartment,
  } = useCustomHook;

  return (<>
    <PageWrapper>
      <HeaderText>
        <Typography level={3} fontWeight="medium">Master vendor</Typography>
      </HeaderText>
      <PageCard>
        <CardContent>
          <TitleContent>
            <img src={BluebirdLogo} alt="" />
            <Typography level={4} fontWeight="medium">
              Daftar vendor
            </Typography>
          </TitleContent>
          <ActionSection>
            <div>
              <Flex>
                <SearchBar onInputSearch={(val) => setParams((curr) => ({ ...curr, search: val }))} hasReset placeholder="Cari data" />
                <FilterDropdown
                  id="vendor-status"
                  options={vendorStatusOpts}
                  label="Status vendor"
                  width="150px"
                  value={params.vendorStatus?.label}
                  onSelected={(opt) => setParams((curr) => ({
                    ...curr,
                    vendorStatus: opt as { label: string, value: string },
                  }))} />
                <FilterDropdown
                  id="approval-status"
                  options={approvalStatusOpts}
                  label="Status approval"
                  width="150px"
                  value={params.vendorApproval?.label}
                  onSelected={(opt) => setParams((curr) => ({
                    ...curr,
                    vendorApproval: opt as { label: string, value: string },
                  }))} />
                <FilterDropdown
                  id="pool"
                  options={userPools?.map((pool) => ({
                    label: pool.poolName,
                    value: pool.poolId,
                  })) || []}
                  label="Pool"
                  value={params.pool?.label}
                  onSelected={(opt) => setParams((curr) => ({
                    ...curr,
                    pool: opt as { label: string, value: string },
                  }))}
                />
                <FilterDropdown
                  id="department"
                  options={allDepartment.map((item) => ({
                    label: item.department,
                    value: item.department,
                  })) || []}
                  label="Departemen"
                  value={params.department?.label || ""}
                  onSelected={(opt) => setParams((curr) => ({
                    ...curr,
                    department: opt as { label: string, value: string },
                  }))}
                />
              </Flex>
            </div>
            <Button
              onClick={() => setModalFormVendor(true)}
              leftIcon={<PlusIcon />}
            >
              Tambah data
            </Button>
          </ActionSection>
          <StickyTable>
            <VendorTable
              showModal={() => setModalFormVendor(true)}
              setEditValue={setEditValues}
              useCustomHook={useCustomHook}
            />
          </StickyTable>
        </CardContent>
      </PageCard>
      <ModalVendorForm
        isOpen={modalFormVendor}
        setClose={(modalState) => {
          setModalFormVendor(modalState);
          setEditValues(undefined);
          setFiles([]);
        }}
        useCustomHook={useCustomHook}
      />

      <ModalViewFile
        useCustomHook={useCustomHook}
      />
    </PageWrapper>
    {isLoading && (
      <PageLoading />
    )}
  </>);
};

export default Vendor;
